module.exports = __webpack_public_path__ + "img/mig-credit.99cfe056.svg";